var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "cartao.mensagem" } }, [
    _vm.modelo == 1
      ? _c("div", { staticClass: "checkout" }, [
          _c("div", { staticClass: "credit-card-box" }, [
            _c("div", { staticClass: "front-message" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "h3",
                {
                  staticStyle: { "margin-top": "10px", "text-align": "center" }
                },
                [_vm._v(" " + _vm._s(_vm.mensagemUsuario) + "  ")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.modelo == 2
      ? _c("div", { staticClass: "checkout2" }, [_vm._m(1)])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "checkout-center", width: "100%" } }, [
      _c("img", {
        staticClass: "image-center",
        attrs: { src: "images/imagem_erro.png", height: "110px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout-message" }, [
      _c("div", { attrs: { id: "checkout-center", width: "100%" } }, [
        _c("img", {
          staticClass: "image-center",
          attrs: { src: "images/imagem_ok.png", height: "110px" }
        })
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Transação realizada com sucesso!")]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("Aguarde a janela fechar automaticamente.")]),
      _c("p")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }